import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Actions = styled.div.withConfig({
  displayName: "Actions",
  componentId: "sc-1if6hg8-0"
})(["display:flex;align-items:center;border-radius:", ";margin-top:auto;", ";font-weight:600;white-space:nowrap;text-align:left;a,span{position:relative;padding:3.5px 9px;padding-right:12px;border:1px solid ", ";border-radius:", ";margin-right:3px;cursor:pointer;color:black;&:hover{border-color:", ";background-color:", ";color:", ";}&:after{position:absolute;top:-3px;bottom:-3px;right:0;content:'';}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, getFont(-1, 'compact'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.followHoverColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.followHoverColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.followHoverFontColor;
});